import { DashboardBlockItemCommonProps } from "@/dashboard/blocks/DashboardBlockItem"
import { useFragment } from "react-relay"
import { graphql } from "relay-runtime"
import DashboardBlockItemTemplate from "../DashboardBlockItemTemplate"
import RecentlyViewedDashboardBlockContent from "./RecentlyViewedDashboardBlockContent"
import { RecentlyViewedDashboardBlockFragment$key } from "./__generated__/RecentlyViewedDashboardBlockFragment.graphql"

interface Props extends DashboardBlockItemCommonProps {
  dashboardBlockKey: RecentlyViewedDashboardBlockFragment$key
}

export default function RecentlyViewedDashboardBlock({
  dashboardBlockKey,
  index,
  dashboardColumnHoveredShowableClass,
}: Props) {
  const block = useFragment<RecentlyViewedDashboardBlockFragment$key>(
    graphql`
      fragment RecentlyViewedDashboardBlockFragment on RecentlyViewedDashboardBlock {
        id
        position
        ...DashboardBlockItemTemplateFragment
        ...DashboardBlockAdminDropdownFragment
      }
    `,
    dashboardBlockKey
  )

  return (
    <DashboardBlockItemTemplate
      dashboardBlockKey={block}
      index={index}
      dashboardColumnHoveredShowableClass={dashboardColumnHoveredShowableClass}
    >
      <RecentlyViewedDashboardBlockContent block={block} />
    </DashboardBlockItemTemplate>
  )
}
